<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="container">
      <div class="page-header">
        <div class="page-title">{{ $t('add.games') }}</div>
      </div>
      <div class="detail-box">
        <GamesBox ref="gamesbox" :postGames="postGames" />
      </div>
    </div>
  </div>
</template>
<script>
import { postGames } from '@/api/user'
import GamesBox from '@/components/GamesBox.vue'

export default {
  name: 'UserActCategory',
  components: { GamesBox },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      postGames
    }
  },
  mounted() {
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== 'UserActList' &&
      to.name !== 'UserActivity' &&
      to.name !== 'UserQuizDetail' &&
      to.name !== 'UserVoteList' &&
      to.name !== 'UserEventList' &&
      to.name !== 'UserSpaceList'
    ) {
      console.log(888)
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    console.log(99999)
    next()
  },
  methods: {
    init() {
      this.$refs.gamesbox.init()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/actcategory.vue